/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Icon from "../ui/Icon";

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

const TagsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  flex: 1;
  max-width: 560px;
`;

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 7px;
  border-radius: 8px;
  background: rgba(${({ theme }) => theme.colors.accent.rgb}, 0.1);
  color: rgba(${({ theme }) => theme.colors.accent.rgba});
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  max-width: 260px;
  min-width: 0;
`;

const TagLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const TagRemove = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  color: inherit;
`;

const ClearAll = styled.button`
  background: none;
  border: none;
  padding: 5px 0;
  margin: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: calc(${({ theme }) => theme.fontSizes.p} * 0.85);
  color: rgba(${({ theme }) => theme.colors.error.rgba});
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  flex-shrink: 0;
`;

const FilterTags = ({ filterGroups = [], selectedFilters = [], onFilterChange, onClearFilters }) => {
  if (!selectedFilters.length) return null;

  const getLabel = (type, id) => {
    const group = filterGroups.find((g) => g.type === type);
    return group?.items?.find((item) => item.id === id)?.name ?? id;
  };

  return (
    <Wrapper>
      <TagsGroup>
        {selectedFilters.map(({ type, id }) => (
          <Tag key={`${type}-${id}`}>
            <TagLabel>{getLabel(type, id)}</TagLabel>
            <TagRemove onClick={() => onFilterChange(type, id)} aria-label="Remove filter">
              <Icon.Cross size={Icon.SIZE.XS} color="secondary" />
            </TagRemove>
          </Tag>
        ))}
      </TagsGroup>
      <ClearAll onClick={onClearFilters}>
        <Icon.Cross size={Icon.SIZE.XS} color="danger" />
        Clear all
      </ClearAll>
    </Wrapper>
  );
};

export default FilterTags;
